import classNames from "classnames";
import { Checkbox } from "PFComponents/checkbox";
import { OptionOriginal } from "PFTypes/options";

import { ListItemComponentProps } from "./list_item";
import css from "./list_item.module.scss";

export const ListItemMultiple = <T extends OptionOriginal = OptionOriginal>({
  id,
  option,
  selected,
  onClick,
  clipOptionsOverflow,
  disabled
}: ListItemComponentProps<T>) => (
  <Checkbox
    id={id}
    checked={selected}
    disabled={option.disabled || disabled}
    onChange={onClick}
    className={classNames(css.listComponent, css.checkbox)}
    tabIndex={-1}
    label={option.displayElement ?? option.value}
    clipLabelOverflow={clipOptionsOverflow}
  />
);
